module.exports = __webpack_public_path__ + "img/TiktokQRcode.bee3c2c7.jpg";